import React from "react";

const FormContext: React.Context<undefined> = React.createContext(undefined);

export default FormContext;
